import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useAuth } from './AuthContext';

export const PrivateRoute = ({
    component: Component,
    requiredPermission,
    ...rest
}) => {
    const { isAuthenticated, checkPermission, isLoading } = useAuth();

    if (isLoading) {
        return <div>Загрузка...</div>;
    }

    return (
        <Route
            {...rest}
            render={(props) => {
                if (!isAuthenticated) {
                    return <Redirect to="/auth" />;
                }

                if (requiredPermission !== null && !checkPermission(requiredPermission)) {
                    return <Redirect to="/no-access" />;
                }

                return <Component {...props} />;
            }}
        />
    );
};